export default __webpack_public_path__ + "static/media/1.24d21287.jpg";